import { Box, Divider } from "@mui/material";
import UnpaidMembershipUpsell from "components/member/UnpaidMembershipUpsell";
import WelcomeHeader from "components/member/home/WelcomeHeader";
import QuickLinks from "components/member/home/QuickLinks";
import FlexBox from "components/common/FlexBox";
import UpcomingVideoCalls from "components/common/UpcomingVideoCalls";
import FeatureSuggestionsModule from "components/member/FeatureSuggestionsModule";
import FutureAdvisorInfo from "components/member/home/FutureAdvisorInfo";
import TaskDiscovery from "components/member/home/TaskDiscovery";
import { HomeLayoutProps } from "./types";

export default ({
  data,
  currentUser,
  isMobile,
  productPrompts,
  handleDismissFeatureSuggestions,
}: HomeLayoutProps) => {
  return (
    <Box sx={{ maxWidth: "900px" }}>
      <Box
        sx={{
          position: "fixed",
          left: "50%",
          transform: "translateX(calc(-50% + 25px))",
          width: "100%",
          backgroundImage: "url('../../assets/images/sparkles.png')",
          backgroundPosition: "top right",
          backgroundRepeat: "no-repeat",
          backgroundSize: "auto",
          backgroundColor: "#D9F0EB",
          zIndex: 1,
          margin: "0px -24px",
          marginTop: "-82px",
          padding: "0px 24px",
          paddingTop: "82px",
          height: "100vh",
        }}
      ></Box>
      <FlexBox
        direction="column"
        gap="16px"
        sx={{ position: "relative", zIndex: 3 }}
      >
        <WelcomeHeader user={currentUser} />
        <UpcomingVideoCalls family={data?.family!} />
      </FlexBox>

      <Box
        sx={{
          boxShadow: "0px -4px 27px 0px rgba(0, 0, 0, 0.10)",
          borderRadius: "32px 32px 0px 0px",
          margin: "-24px",
          marginTop: "24px",
          padding: isMobile ? "32px 24px" : "24px",
          backgroundColor: "#FFF",
          display: "flex",
          flexDirection: "column",
          gap: isMobile ? "32px" : "24px",
          position: "relative",
          zIndex: 10,
        }}
      >
        <UnpaidMembershipUpsell />
        <Divider />

        <FutureAdvisorInfo />

        <Divider />
        {productPrompts?.featureSuggestionsDismissed !== "dismissed" && (
          <>
            <FeatureSuggestionsModule
              onDismiss={handleDismissFeatureSuggestions}
            />
            <Divider />
          </>
        )}
        {productPrompts?.featureSuggestionsDismissed === "dismissed" && (
          <Divider />
        )}
        <TaskDiscovery />
        <Divider />
        <QuickLinks />
      </Box>
    </Box>
  );
};
